import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BASE}/api`,
    // Timeout generoso (60s) — em produção o backend pode demorar
    // a acordar de cold start (cluster k8s) ou estar sob carga.
    // Melhor esperar do que falhar com timeout prematuro.
    timeout: 60000,
});

// Anexa Bearer token a cada request, lê do localStorage
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("salvador_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

// Em 401 limpa token (sessão expirada)
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("salvador_token");
            localStorage.removeItem("salvador_user");
        }
        return Promise.reject(err);
    },
);

// Helper para extrair mensagens de erro Pydantic ou string
export const apiError = (e) => {
    const d = e?.response?.data?.detail;
    if (d) {
        if (typeof d === "string") return d;
        if (Array.isArray(d))
            return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
        if (typeof d === "object") return d.message || d.error || JSON.stringify(d);
        return String(d);
    }
    // Sem resposta do servidor: traduzimos o "Network Error" do axios para PT-PT
    // claro. Pode ser: servidor a acordar (cold start), sem internet, CORS, etc.
    const msg = e?.message || "";
    if (msg === "Network Error" || /network|fetch failed/i.test(msg)) {
        return "Sem ligação ao servidor. Verifica a internet ou tenta novamente em alguns segundos.";
    }
    if (/timeout|ECONNABORTED/i.test(msg)) {
        return "O servidor demorou demasiado a responder. Tenta novamente.";
    }
    return msg || "Erro de ligação";
};
